export default __webpack_public_path__ + "1f8cb2923845ba0151e3c7fa3073d797.png";